import { createElement } from "react";
import { HOMEPAGE_HERO_TEXT_COLOR } from "@/components/Homepage/HomepageHero/constants";
import CircleCheckOutline from "@/components/icons/CircleCheckOutline";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";
import validateHex from "@/utils/functions/validateHex";
import useTranslations from "@/i18n/useTranslations";

type HomepageHeroHeadingProps = {
  title?: string;
  titleColor?: string;
  descriptionItems?: string[];
  descriptionColor?: string;
  headingLevel?: "h1" | "h2";
  headingClassName?: string;
};

export default function HomepageHeroHeading({
  title,
  titleColor = HOMEPAGE_HERO_TEXT_COLOR,
  descriptionItems,
  descriptionColor = HOMEPAGE_HERO_TEXT_COLOR,
  headingLevel = "h1",
  headingClassName,
}: HomepageHeroHeadingProps) {
  const t = useTranslations("Homepage");
  const resolvedTitle = title ?? t("learnAnywhereWithEdx");
  const titleColorHex = validateHex(titleColor) ?? HOMEPAGE_HERO_TEXT_COLOR;
  const descriptionColorHex = descriptionColor
    ? validateHex(descriptionColor)
    : HOMEPAGE_HERO_TEXT_COLOR;

  const getDescription = () => {
    if (!descriptionItems) {
      return null;
    }
    if (descriptionItems.length > 1) {
      return (
        <ul className="flex flex-col gap-4 list-none !p-0 mt-0 mb-8">
          {descriptionItems.map((item) => (
            <li
              key={item}
              className="elm-p5"
              style={{ color: descriptionColorHex }}
            >
              <div className="inline-block align-middle mr-2">
                <CircleCheckOutline svgProps={{ width: 32, height: 32 }} />
              </div>
              <span className="align-middle">{boldTextWithAsterisk(item)}</span>
            </li>
          ))}
        </ul>
      );
    }
    return (
      <p className="elm-p5 mb-8" style={{ color: descriptionColorHex }}>
        {boldTextWithAsterisk(descriptionItems[0])}
      </p>
    );
  };

  return (
    <>
      {createElement(
        headingLevel,
        {
          className:
            headingClassName ?? "elm-d3 font-black italic p-0 mt-0 mb-6",
          style: { color: titleColorHex },
        },
        resolvedTitle,
      )}
      {getDescription()}
    </>
  );
}
